import { render, staticRenderFns } from "./bulk_requests.vue?vue&type=template&id=e8539294&scoped=true"
import script from "./bulk_requests.vue?vue&type=script&lang=js"
export * from "./bulk_requests.vue?vue&type=script&lang=js"
import style0 from "./bulk_requests.vue?vue&type=style&index=0&id=e8539294&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8539294",
  null
  
)

export default component.exports